import { useTokens } from '../context/TokenProvider';
const boxShadow = '-1px 1px 1px 1px rgba(170,170,170,0.25)';
const mozBoxShadow = '-3px 2px 3px 1px rgba(170,170,170,0.25)';
const useStyling = () => {
    const tokens = useTokens();
    const tableContainerRounded = {
        w: '100%',
        borderRadius: tokens.BorderRadius04,
        'box-shadow': boxShadow,
        '-webkit-box-shadow': boxShadow,
        '-moz-box-shadow': mozBoxShadow,
    };
    const tableContainerCard = {
        w: '100%',
        borderRadius: tokens.BorderRadius04,
        boxShadow: 'none',
    };
    const thumbnailImages = {
        shadow: '0px 2px 4px 0px rgba(26, 26, 26, 0.20)',
        borderRadius: tokens.BorderRadius04,
        border: `${tokens.BorderWidth02} solid ${tokens.BorderWhite100}`,
        cursor: 'pointer',
        mt: tokens.Spacing01,
        _focus: {
            boxShadow: 'none',
            outline: 'none',
        },
        _focusVisible: {
            outline: `1px solid ${tokens.BorderFocus}`,
            outlineOffset: 0,
        },
        float: {
            sm: 'left',
        },
        mr: {
            base: 0,
            lg: 0,
            sm: tokens.Spacing04,
        },
    };
    const datePickerStyles = {
        input: {
            px: tokens.Spacing05,
            py: tokens.Spacing04,
            borderWidth: tokens.BorderWidth01,
            borderRadius: tokens.BorderRadius02,
            backgroundColor: tokens.Grey200,
            borderColor: tokens.BorderLight500,
            textColor: tokens.TextLight500,
            height: 10,
            w: '100%',
            _hover: {
                background: tokens.Layer01,
                borderColor: tokens.BorderLight500,
            },
            _focus: {
                color: tokens.TextMedium600,
                outlineColor: tokens.BorderFocus,
                outlineWidth: tokens.BorderWidth02,
                borderColor: tokens.BorderDark800,
                bgColor: tokens.Layer01,
                background: tokens.Layer01,
            },
            _active: {
                textColor: tokens.TextBlack800,
                borderColor: tokens.BorderDark800,
            },
            _focusVisible: {
                shadow: 'none',
            },
        },
        svg: {
            right: 1,
            top: 1,
            fill: tokens.IconLight500,
        },
    };
    return {
        tableContainer: {
            rounded: tableContainerRounded,
            roundedWithPadding: {
                ...tableContainerRounded,
                td: {
                    padding: tokens.Spacing04,
                },
            },
            card: {
                ...tableContainerCard,
                td: {
                    py: 0,
                },
            },
            cardWithPadding: {
                ...tableContainerCard,
                td: {
                    padding: tokens.Spacing04,
                },
            },
        },
        tableBody: {
            noHover: {
                td: {
                    cursor: 'default',
                },
            },
        },
        photoGrid: {
            h: '228px',
            minW: '224px',
            thumbnail: {
                cursor: 'pointer',
            },
        },
        photoItem: {
            borderWidth: tokens.BorderWidth01,
            borderRadius: tokens.BorderRadius02,
            borderColor: tokens.BorderMedium600,
            position: 'relative',
            _focus: {
                outline: 'none',
                boxShadow: 'none',
            },
            _focusVisible: {
                boxShadow: 'none',
                outline: `1px solid ${tokens.BorderFocus}`,
                outlineOffset: tokens.Spacing01,
            },
            badge: {
                position: 'absolute',
                bottom: 1,
                right: 1,
            },
        },
        mediaViewer: {
            height: '596px',
            mt: '125px',
            mr: tokens.Spacing01,
            position: 'relative',
            closeButton: {
                float: 'right',
                mt: '40px',
            },
            thumbnailWrapper: {
                width: {
                    base: '135px',
                    lg: '135px',
                    sm: '100%',
                },
                height: '596px',
                overflow: 'auto',
                float: 'left',
                ml: tokens.Spacing02,
                marginTop: {
                    base: 0,
                    lg: 0,
                    sm: '605px',
                },
                deselectedImage: {
                    ...thumbnailImages,
                    img: {
                        w: '100px',
                        h: '100px',
                        opacity: 0.6,
                        borderRadius: tokens.BorderRadius04,
                        border: `${tokens.BorderWidth01} solid transparent`,
                    },
                },
                selectedImage: {
                    ...thumbnailImages,
                    border: `${tokens.BorderWidth04} solid ${tokens.BorderFocus}`,
                    img: {
                        w: '96px',
                        h: '96px',
                        opacity: 1,
                        borderRadius: tokens.BorderRadius02,
                    },
                },
            },
            '#image-wrapper': {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: {
                    base: '1068px',
                    lg: '1068px',
                    sm: '100%',
                },
                position: {
                    base: 'relative',
                    lg: 'relative',
                    sm: 'absolute',
                },
                height: '596px',
                bg: tokens.Layer01,
                borderWidth: tokens.BorderWidth01,
                borderColor: tokens.BorderLight200,
                float: {
                    base: 'right',
                    lg: 'right',
                    sm: 'none',
                },
                marginRight: '26px',
                div: {
                    position: {
                        base: 'relative',
                        lg: 'relative',
                        sm: 'absolute',
                    },
                },
                img: {
                    margin: 'auto',
                    width: 'auto',
                    height: 'auto',
                    maxHeight: '100%',
                },
            },
        },
        datePicker: datePickerStyles,
    };
};
export default useStyling;
